// Mapping form works independently of the optional GSAP/Three visual enhancement.
let turnstileLoader;
function loadTurnstile() {
  if (window.turnstile?.render) return Promise.resolve(window.turnstile);
  if (turnstileLoader) return turnstileLoader;
  turnstileLoader = new Promise((resolve, reject) => {
    let script = document.querySelector('script[src^="https://challenges.cloudflare.com/turnstile/v0/api.js"]');
    const owned = !script;
    if (owned) {
      script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.dataset.mgTurnstile = '';
    }
    let poll, timer;
    const finish = (error) => {
      clearInterval(poll); clearTimeout(timer);
      script.removeEventListener('error', failed);
      if (error) { if (owned) script.remove(); reject(error); }
      else resolve(window.turnstile);
    };
    const failed = () => finish(new Error('verification'));
    script.addEventListener('error', failed, {once: true});
    poll = setInterval(() => { if (window.turnstile?.render) finish(); }, 80);
    timer = setTimeout(failed, 12000);
    if (owned) document.head.append(script);
  }).catch(error => { turnstileLoader = null; throw error; });
  return turnstileLoader;
}
const instances = new WeakMap();
function mount(root) {
  if (instances.has(root)) return;
  const form = root.querySelector('[data-mg-form]');
  if (!form) return;
  let active = true, busy = false, accepted = form.classList.contains('is-accepted'), disposeMotion = () => {};
  const abort = new AbortController(), loadedAt = Date.now();
  const email = form.querySelector('[name="email"]');
  const consent = form.querySelector('[name="newsletter_consent"]');
  const trap = form.querySelector('[name="last_name"]');
  const status = form.querySelector('.form-status');
  const content = form.querySelector('[data-mg-form-content]');
  const success = form.querySelector('[data-mg-success]');
  const emailError = form.querySelector('.field-error:not(.consent-error)');
  const consentError = form.querySelector('.consent-error');
  const button = form.querySelector('.submit'), label = button.querySelector('span');
  const defaultLabel = label.textContent;
  let widget = null, pending = null, tokenTimer = 0;
  const listen = (element, name, fn, options = {}) => element.addEventListener(name, fn, {...options, signal: abort.signal});
  function settleToken(error, token) {
    if (!pending) return;
    const current = pending; pending = null; clearTimeout(tokenTimer);
    if (error) current.reject(error); else current.resolve(token);
  }
  async function token() {
    const api = await loadTurnstile();
    if (!active) throw new Error('unloaded');
    if (widget === null) {
      widget = api.render(form.querySelector('[data-mg-turnstile]'), {
        sitekey: root.dataset.siteKey, action: 'mapping_guide', execution: 'execute',
        appearance: 'interaction-only', retry: 'never',
        callback: value => settleToken(null, value),
        'error-callback': () => { settleToken(new Error('verification')); return true; },
        'expired-callback': () => settleToken(new Error('verification')),
        'timeout-callback': () => settleToken(new Error('verification'))
      });
    }
    api.reset(widget);
    return new Promise((resolve, reject) => {
      pending = {resolve, reject};
      tokenTimer = setTimeout(() => settleToken(new Error('verification')), 30000);
      try { api.execute(widget); } catch { settleToken(new Error('verification')); }
    });
  }
  function showAccepted(preview = false) {
    // A 202 from Klaviyo means the request was accepted, not that delivery is confirmed.
    form.style.minHeight = form.getBoundingClientRect().height + 'px';
    accepted = true; form.classList.add('is-accepted'); button.classList.add('is-accepted');
    label.textContent = 'Anforderung erhalten';
    button.disabled = true; email.readOnly = true; consent.disabled = true;
    status.textContent = '';
    content.hidden = true;
    success.querySelector('[data-mg-preview-note]').hidden = !preview;
    success.hidden = false;
    sticky.classList.remove('visible'); sticky.inert = true; sticky.setAttribute('aria-hidden','true');
    success.focus({preventScroll:true});
    success.scrollIntoView({block:'nearest',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  }
  function clear(field, box) { field.removeAttribute('aria-invalid'); box.hidden = true; box.textContent = ''; }
  function error(field, box, text) {
    field.setAttribute('aria-invalid', 'true'); box.hidden = false; box.textContent = text;
    field.focus({preventScroll: true});
    field.scrollIntoView({block: 'center', behavior: 'auto'});
  }
  listen(email, 'input', () => { if(email.validity.valid)clear(email,emailError); if(!accepted)status.textContent=''; });
  listen(consent, 'change', () => { if(consent.checked)clear(consent,consentError); if(!accepted)status.textContent=''; });
  listen(form, 'submit', async event => {
    event.preventDefault();
    if (busy || accepted) return;
    status.textContent = '';
    // Same two pre-Turnstile layers as SPIKE: fake surname + minimum 1.5 seconds.
    if (trap.value.trim() !== '' || Date.now() - loadedAt < 1500) return;
    clear(email, emailError); clear(consent, consentError);
    email.value = email.value.trim();
    if (!email.validity.valid) {
      error(email, emailError, email.validity.valueMissing ? 'Bitte gib deine E-Mail-Adresse ein.' : 'Bitte gib eine gültige E-Mail-Adresse ein.'); return;
    }
    if (!consent.checked) {
      error(consent, consentError, 'Bitte bestätige deine Newsletter-Anmeldung, um den Guide zu erhalten.'); return;
    }
    const workerUrl = root.dataset.workerUrl || '';
    if (root.dataset.preview === 'true' || root.dataset.designMode === 'true' || (!workerUrl && ['127.0.0.1','localhost'].includes(location.hostname))) {
      showAccepted(true); return;
    }
    try { if (new URL(workerUrl).protocol !== 'https:') throw new Error(); }
    catch { status.textContent = 'Die Anforderung ist gerade nicht verfügbar. Bitte versuche es später erneut.'; return; }

    // Freeze the values the visitor consented to while verification is pending.
    const submittedEmail = email.value.toLowerCase(), elapsed = Date.now() - loadedAt;
    busy = true; button.disabled = true; email.readOnly = true; consent.disabled = true;
    form.setAttribute('aria-busy','true'); label.textContent = 'Einen Moment …';
    let networkTimer;
    const network = new AbortController();
    const cancelNetwork = () => network.abort();
    abort.signal.addEventListener('abort', cancelNetwork, {once:true});
    try {
      const challenge = await token();
      if (!active) return;
      networkTimer = setTimeout(cancelNetwork, 25000);
      const response = await fetch(workerUrl, {
        method:'POST', credentials:'omit',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({
          email:submittedEmail, token:challenge, newsletter_consent:true,
          last_name:trap.value, elapsed_ms:elapsed, page_path:location.pathname
        }), signal:network.signal
      });
      const result = await response.json();
      if (!response.ok || result.success !== true || !result.request_id) {
        throw new Error(response.status === 403 ? 'verification' : 'request');
      }
      if (!active) return;
      showAccepted();
      try {
        const analytics = window.Shopify?.analytics;
        if (analytics?.publish) {
          const published = analytics.publish('mapping_guide_requested', {
            content_name:'Mapping auf einen Blick', guide_pages:8,
            request_status:'accepted', request_id:result.request_id
          });
          if(published?.catch)published.catch(() => {});
        }
      } catch {}
    } catch (failure) {
      if(active)status.textContent = failure.message === 'verification'
        ? 'Die Sicherheitsprüfung hat nicht geklappt. Bitte versuche es erneut.'
        : 'Das hat gerade nicht geklappt. Bitte versuche es erneut.';
    } finally {
      clearTimeout(networkTimer); abort.signal.removeEventListener('abort', cancelNetwork);
      busy = false;
      if(active){
        button.disabled = accepted; email.readOnly = accepted; consent.disabled = accepted;
        form.removeAttribute('aria-busy');
        if(!accepted)label.textContent = defaultLabel;
      }
    }
  });
  root.querySelectorAll('a[href="#'+form.id+'"]').forEach(link => listen(link, 'click', event => {
    event.preventDefault();
    form.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    if (accepted) success.focus({preventScroll:true});
  }));
  const sticky = root.querySelector('.sticky-cta');
  const actions = Array.from(root.querySelectorAll('.offer-cta,.value-cta,.submit'));
  const visible = new Set([actions[0]]);
  let observer;
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(entries => {
      for(const entry of entries){ if(entry.isIntersecting)visible.add(entry.target);else visible.delete(entry.target); }
      const show = visible.size === 0 && !accepted;
      sticky.classList.toggle('visible',show); sticky.inert = !show; sticky.setAttribute('aria-hidden',String(!show));
    },{threshold:0});
    actions.forEach(action => observer.observe(action));
  }
  // Lazy, failure-tolerant visual layer. Static cover and the form remain usable.
  import('./mg-motion.js').then(module => { if(active)disposeMotion=module.initMotion(root); }).catch(() => {});
  const unmount = () => {
    active = false; abort.abort(); observer?.disconnect();
    settleToken(new Error('unloaded'));
    if(widget!==null)try{window.turnstile?.remove(widget);}catch{}
    disposeMotion(); instances.delete(root);
  };
  instances.set(root,unmount);
}
function mountWithin(container) {
  if(container.matches?.('[data-mg-root]'))mount(container);
  container.querySelectorAll?.('[data-mg-root]').forEach(mount);
}
mountWithin(document);
document.addEventListener('shopify:section:load', event => mountWithin(event.target));
document.addEventListener('shopify:section:unload', event => {
  event.target.querySelectorAll('[data-mg-root]').forEach(root => instances.get(root)?.());
});
window.addEventListener('pagehide', event => {
  if(!event.persisted)document.querySelectorAll('[data-mg-root]').forEach(root => instances.get(root)?.());
});
